import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Section } from "@miro-site/core";
import React from "react";
var defaultCard = {
    paddingLeft: 10,
    paddingRight: 10,
    width: [
        "50%",
        "33.33%"
    ],
    marginTop: [
        28,
        40
    ]
};
var highlightedCard = {
    paddingLeft: 10,
    paddingRight: 10,
    width: [
        "100%",
        "50%"
    ],
    marginTop: [
        32,
        20
    ]
};
var CardGrid = function(_param) {
    var isHighlighted = _param.isHighlighted, children = _param.children, top = _param.top, props = _object_without_properties(_param, [
        "isHighlighted",
        "children",
        "top"
    ]);
    return /*#__PURE__*/ _jsx(Section, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                top && /*#__PURE__*/ _jsx(Box, {
                    children: top
                }),
                /*#__PURE__*/ _jsx(Box, {
                    $styles: {
                        display: "flex",
                        marginLeft: -10,
                        flexFlow: "row wrap"
                    },
                    children: React.Children.map(children, function(child) {
                        return /*#__PURE__*/ _jsx(Box, {
                            $styles: isHighlighted ? highlightedCard : defaultCard,
                            children: child
                        });
                    })
                })
            ]
        })
    }));
};
export default CardGrid;
